





















































import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import {getModule} from "vuex-module-decorators";
import DeploymentStore from "@/store/deployment";
import MessageDialog from "@/components/MessageDialog.vue";
import ProfileStore from "@/store/profile";

const profile = getModule(ProfileStore);
const deployments = getModule(DeploymentStore);

@Component({
    components: {MessageDialog}
})
export default class App extends Vue {

    @Prop() version = ""

    get canCreateDeployment(): boolean {
        return deployments.resources.memoryMBUsed <= deployments.resources.memoryMBLimit
    }

    get profile() {
       return profile.profile
    }
}
